





































import { defineComponent, Ref, ref, onMounted, watch, onUnmounted, computed, ComputedRef } from "@vue/composition-api";
import axios from 'axios';
// Store
import { Endpoints, Mutations } from '@/ts/store/Constants';
import { Actions } from '@/ts/store/modules/Channels/constants';

// types
import { ChannelMember } from '@/views/Admin/Channels/channelTypes';
import ErrorResponse from '@/ts/ErrorResponse';

// components
import BaseAvatar from '@/components/NEW-STRUCTURE/desktop/Admin/components/BaseAvatar.vue';
import SubTitle from '@/components/NEW-STRUCTURE/desktop/Admin/titles/SubTitle.vue';

export default defineComponent({
    components: {
        BaseAvatar,
        SubTitle,
    },
    props: {
        channelId: String,
    },
    setup(props, { root, emit }) {
        const store = root.$store;

        const bannedMembers: ComputedRef<ChannelMember[]> = computed(() => {
            return store.getters['Channels/getBannedUsers'];
        });

        const channelTabs: ComputedRef<any> = computed(() => {
            return store.getters['Channels/getChannelsTabs'];
        });

        const handleGoBack = () => {
            const { CHANNEL_INFO } = channelTabs.value;
            emit('changeManagementTab', CHANNEL_INFO);
        }

        const fetchChannelBannedMembers = () => {
            if (props.channelId) {
                store.dispatch(Actions.FETCH_BANNED_USERS, props.channelId);
            }
        };

        const restoreMessages = (userId: number) => {
            if (props.channelId) {
                 axios.post(Endpoints.Admin.Channels.RESTORE_MESSAGES(props.channelId, userId))
                .then(() => {
                })
                .catch((error) => {
                    if (error.response) {
                        const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                        store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                    } else {
                        console.log(error);
                    }
                });
            }
        };

        const unblock = (userId: number) => {
            axios.delete(Endpoints.Admin.Channels.CHANNEL_UNBLOCK_USER(props.channelId, userId))
                .then(() => {
                    //restoreMessages(userId);
                    fetchChannelBannedMembers();

                    //store.commit(Mutations.SET_FETCH_MESSAGES, true);
                })
                .catch((error) => {
                    if (error.response) {
                        const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                        store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                    } else {
                        console.log(error);
                    }
                });
        }

        watch(() => props.channelId, (newValue, oldValue) => {
            if (!oldValue || (newValue && (newValue !== oldValue))) {
                fetchChannelBannedMembers();
            }
        });

        onMounted(() => {
            fetchChannelBannedMembers();
        });

        return {
            bannedMembers,
            fetchChannelBannedMembers,
            handleGoBack,
            unblock,
        };
    }
});
